import React from 'react';
import PropTypes from 'prop-types';
import ProgressBar from './ProgressBar';
import Status from './Status';
import Feedback from './Feedback';
import { TextWrapper } from './styled';

/**
 * SingleDataColumn
 * @param children {node}
 * @returns {JSX.Element}
 */
const SingleDataColumn = ({ children }) => (
  <TextWrapper>{children}</TextWrapper>
);

SingleDataColumn.propTypes = {
  children: PropTypes.node
};

SingleDataColumn.ProgressBar = ProgressBar;
SingleDataColumn.Status = Status;
SingleDataColumn.Feedback = Feedback;

export default SingleDataColumn;
